import { render, staticRenderFns } from "./TextRecommendations.vue?vue&type=template&id=28fd250a&scoped=true"
import script from "./TextRecommendations.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendations.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendations.vue?vue&type=style&index=0&id=28fd250a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd250a",
  null
  
)

export default component.exports